import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.841 9.716c.124 2.053.186 4.718.186 7.999 0 7.047-.285 15.523-.856 25.429a1.966 1.966 0 0 1-3.353 1.277l-8.022-8.022c-.601-.601-.843-.764-1.16-.86a1.25 1.25 0 0 0-.744 0c-.319.096-.56.259-1.161.86l-8.025 8.025a1.966 1.966 0 0 1-3.353-1.274c-.569-9.647-.853-18.093-.853-25.34 0-3.322.06-6.013.18-8.077a6.882 6.882 0 0 1 6.255-6.455C19.002 3.092 21.445 3 24.263 3c2.817 0 5.257.092 7.322.277a6.882 6.882 0 0 1 6.256 6.44ZM24.263 17.34l4.22-4.22c.928-.927 2.318.463 1.391 1.39l-4.22 4.22 4.22 4.221c.927.927-.463 2.317-1.39 1.39l-4.22-4.22-4.22 4.22c-.928.927-2.318-.463-1.391-1.39l4.22-4.22-4.22-4.22c-.927-.928.463-2.318 1.39-1.391l4.22 4.22Z",
    fill: "currentColor"
  }));
};

var SvgBookmarkDelete = styled(SvgComponent).withConfig({
  displayName: "BookmarkDelete__SvgBookmarkDelete",
  componentId: "sc-1m5z9e8-0"
})(["", " ", ""], size, color);
export default SvgBookmarkDelete;